
const url = 'angaza-review';

export const itemRoutes = {
  list: `/admin/${url}`,
};

